import type { SxProps } from '@mui/material'; // if you're using MUI styling
import { BazanPriorityValues } from '../../enums/bazan';
import { Icon } from '@/units/index';
import { NotePriority } from '../../enums';

type BazanPriorityIconProps = {
  priority: BazanPriorityValues;
  size?: number;
  sx?: SxProps;
};

export const BazanPriorityIcon = ({ priority, size = 14, sx }: BazanPriorityIconProps) => {
  const iconStyle = { fontSize: `${size}px !important`, ...sx };

  switch (priority) {
    case BazanPriorityValues.Highest:
      return <Icon.HighestPriority sx={iconStyle} />;
    case BazanPriorityValues.High:
      return <Icon.HighPriority sx={iconStyle} />;
    case BazanPriorityValues.Medium:
      return <Icon.MediumPriority sx={iconStyle} />;
    case BazanPriorityValues.Low:
      return <Icon.LowPriority sx={iconStyle} />;
    default:
      return <Icon.MediumPriority sx={iconStyle} />;
  }
};

type PriorityIconProps = {
  priority: NotePriority;
  size?: number;
  sx?: SxProps;
};

export const PriorityIcon = ({ priority, size = 14, sx }: PriorityIconProps) => {
  const iconStyle = { fontSize: `${size}px !important`, ...sx };

  switch (priority) {
    case NotePriority.Highest:
      return <Icon.HighestPriority sx={iconStyle} />;
    case NotePriority.High:
      return <Icon.HighPriority sx={iconStyle} />;
    case NotePriority.Medium:
      return <Icon.MediumPriority sx={iconStyle} />;
    case NotePriority.Low:
      return <Icon.LowPriority sx={iconStyle} />;
    case NotePriority.Lower:
      return <Icon.LowerPriority sx={iconStyle} />;
    case NotePriority.Lowest:
      return <Icon.LowestPriority sx={iconStyle} />;
    default:
      return <Icon.MediumPriority sx={iconStyle} />;
  }
};
